import React from "react";
import { useInput } from "react-admin";

import MaterialUiCountrySelect from "../PhoneNumber/CountryCodeSelector";
import { useTranslatedInputLabel } from "../../hooks/useTranslatedInputLabel";

export const CountryCodeInput = (props) => {
    const {
        input: { name, onChange, value, onBlur, onFocus },
        meta: { touched, error },
        isRequired
    } = useInput(props);

    const label = useTranslatedInputLabel(props);

    return (
        <MaterialUiCountrySelect
            {...props}
            name={name}
            label={label}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            error={!!(touched && error)}
            helperText={touched && error}
            required={isRequired}
        />
    );
};
